<div class="mat-elevation-z8">
  <table mat-table [dataSource]="dataSource" *ngIf="!boolean">
    <!-- Position Column -->
    <ng-container matColumnDef="date">
      <th mat-header-cell *matHeaderCellDef>Fecha</th>
      <td mat-cell *matCellDef="let element">
        <p>
          {{ element.date | date : "dd-MM-yyyy" }}
        </p>
      </td>
    </ng-container>

    <!-- Name Column -->
    <ng-container matColumnDef="message">
      <th mat-header-cell *matHeaderCellDef>Descripcion</th>
      <td mat-cell *matCellDef="let element">
        <p>
          {{ element.message }}
        </p>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  <div style="width: 100;">
    <mat-spinner style="margin: 10px auto;" *ngIf="boolean" [diameter]="50"></mat-spinner>
  </div>

  <mat-paginator
    [pageSizeOptions]="[5, 10, 20]"
    showFirstLastButtons
    aria-label="Select page of periodic elements"
  >
  </mat-paginator>
</div>
